import React from 'react';
import {useSelector} from 'react-redux';
import {
  selectMissionActiveObjectives,
  selectMissionCompletedObjectiveIds,
  selectIsMissionActive,
} from '../../../redux/reducers/privateStateReducer/selectors';
import {getMissionObjectiveText} from '../../../utils/missions/missionObjectives';
import './MissionTasksPanel.css';

/**
 * Задания сюжетной миссии — выглядят как задание обучения (плашка в цвете
 * внимания с пульсирующей полосой слева), но живут ВСЕГДА в боковой панели
 * списка игроков: и на десктопе, и на мобильном. У обучения поведение
 * прежнее — там на узких экранах задача висит отдельной плашкой в углу.
 *
 * Главные задания идут первыми, промежуточные — под ними; выполненные
 * гасятся и получают галочку.
 */
const MissionTasksPanel = () => {
  const isMissionActive = useSelector(selectIsMissionActive);
  const objectives = useSelector(selectMissionActiveObjectives);
  const completedIds = useSelector(selectMissionCompletedObjectiveIds);

  if (!isMissionActive || objectives.length === 0) {
    return null;
  }

  const mainObjectives = objectives.filter((objective) => objective.isMain);
  const sideObjectives = objectives.filter((objective) => !objective.isMain);

  const renderObjective = (objective) => {
    const isCompleted = completedIds.includes(objective.id);

    return (
      <div
        key={objective.id}
        className={[
          'mission-tasks-panel_task',
          objective.isMain ? 'mission-tasks-panel_task--main' : '',
          isCompleted ? 'mission-tasks-panel_task--completed' : '',
        ].filter(Boolean).join(' ')}
      >
        {isCompleted && (
          <img className={'mission-tasks-panel_check'} src={'/img/icons/check.png'} alt={'Выполнено'}/>
        )}
        <span>{getMissionObjectiveText(objective)}</span>
      </div>
    );
  };

  return (
    <div className={'mission-tasks-panel'}>
      <h2 className={'mission-tasks-panel_header'}>Задания миссии:</h2>
      {mainObjectives.map(renderObjective)}
      {sideObjectives.length > 0 && (
        <h3 className={'mission-tasks-panel_subheader'}>Дополнительно:</h3>
      )}
      {sideObjectives.map(renderObjective)}
    </div>
  );
};

export default MissionTasksPanel;
